export default "__VITE_ASSET__Ccw$F4KO__"